export default __webpack_public_path__ + "static/media/add-plus-circle-white.9aec3381.svg";